<template>
  <div
    class="selected-colors"
    :class="{
      reverse: isReversedLayout,
    }"
  >
    <slot name="item-back" />
    <slot name="item-front" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      isReversedLayout: "config/getIsReversedLayout",
    }),
  },
  watch: {},
  destroyed () {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.selected-colors {
  display: flex;
  flex-direction: row;
  flex-grow: 1;

  &.reverse {
    flex-direction: row-reverse;
  }
}
</style>
